import GlobalVars from '../common/GlobalVars';
import * as Utils from '../common/Utils';
import {
  close as popinClose,
  create as popinCreate,
  open as popinOpen
} from '../common/organism/popin';

require('jqmask');

const openKoreaTermsConditions = {
  needAgreement: false,
  agreed: false,

  popupWindow: null,

  labelInitialHTML: '',

  countriesList: [
    'korea',
  ],

  selectors: {
    container: '[id$=conditions_Container], #contact_form .form_bloc_full div[data-ocms-terms-conditions=true]',
    label: 'label[id$=conditions_field], [data-ocms-terms-conditions=true]',
  },

    /**
     * Loads the popup window.
     *
     * @param {String} asURL - The URL to load.
    */
  load: (asURL) => {
    if (Utils.isEmpty(asURL)) {
      return false;
    }

    if (window.OCMS.controls.termsconditions.popupWindow == null
      || window.OCMS.controls.termsconditions.popupWindow.closed) {
      window.OCMS.controls.termsconditions.needAgreement = true;

      // Transform the given URL to use the same protocol + ensure cross-domain
      let transformedURL = asURL;
      let urlData = Utils.getDataFromURL(asURL);
      if (Utils.isEmpty(urlData)) {
        // Handle relative URL

        transformedURL = `${window.location.protocol}//${window.location.host}/${asURL.replace(/^\/+/, '')}`;
        urlData = Utils.getDataFromURL(transformedURL);
      }

      if (!Utils.isEmpty(urlData)) {
        transformedURL = `${window.location.protocol}//${urlData.host}${urlData.pathname}`;
        if (!Utils.isEmpty(urlData.search)) {
          transformedURL += urlData.search;

          if (Utils.isHTTPS()) {
            transformedURL += '&ssl=true';
          }
        } else if (Utils.isHTTPS()) {
          transformedURL += '?ssl=true';
        }

        if (!Utils.isEmpty(urlData.hash)) {
          transformedURL += urlData.hash;
        }
      } else if (Utils.isHTTPS()) {
        transformedURL += '?ssl=true';
      }

      // Set the "lightview" mode
      transformedURL += `${((transformedURL.indexOf('?') > -1) ? '&' : '?')}nohead=true`;

      // Open the popup
      window.OCMS.controls.termsconditions.popupWindow = window.open(transformedURL, 'termsConditionsWindow', `location=no,status=no,scrollbars=1,close=no,width=${(GlobalVars.IsMobile ? window.innerWidth : 1000).toString()},height=${(GlobalVars.IsMobile ? window.innerHeight : 768).toString()}`);

      // See OCMS.ui.termsAndConditions for adding buttons
      // in the "T&C" page + call handleAgreement
      // only when user has clicked on the agree button (in the "T&C" page)
    } else {
      // Set focus on the popup
      window.OCMS.controls.termsconditions.popupWindow.focus();
    }

    return true;
  },


  /**
   * Handles the click on the "T&C" container.
   *
   * @param {Object} aoEvent - The related event.
  */
  handleClick: function handleClick(aoEvent) {
    const $container = $(this);

    if (!$container.is(window.OCMS.controls.termsconditions.selectors.container)) {
      return true;
    }
    aoEvent.preventDefault();

    let url = null;
    const link = $container.find('a');
    if (link.length) {
      url = Utils.value(link.attr('href'), null);
    }
    if (url != null) {
      return window.OCMS.controls.termsconditions.load(url);
    }

    return false;
  },

  /**
   * Handles the user agreement.
   */
  handleAgreement: () => {
    window.OCMS.controls.termsconditions.needAgreement = false;
    window.OCMS.controls.termsconditions.agreed = true;

    const container = $(window.OCMS.controls.termsconditions.selectors.container);
    if (container.length) {
      const label = container.find(window.OCMS.controls.termsconditions.selectors.label);
      if (label.length) {
        if (!Utils.isEmpty(window.OCMS.controls.termsconditions.labelInitialHTML)) {
          // Reset initial HTML for the label
          label.html(window.OCMS.controls.termsconditions.labelInitialHTML);
        }
      }

      // Remove handler for a click on the "T&C" container
      $(document).off('click', window.OCMS.controls.termsconditions.selectors.container, window.OCMS.controls.termsconditions.handleClick);

      // Check the checkbox
      const checkbox = container.find('input[type=checkbox]');
      if (checkbox.length) {
        checkbox.prop('readonly', true);
        checkbox.click();
        checkbox.prop('checked', true);
      }

      // Hide the "validationerror" label (if any)
      const errorLabel = container.find('label.validationerror');
      if (errorLabel.length) {
        errorLabel.hide();
      }
    }
  },

  /**
   * Handles the user disagreement.
  */
  handleDisagreement: () => {
    window.OCMS.controls.termsconditions.needAgreement = true;
    window.OCMS.controls.termsconditions.agreed = false;

    const container = $(window.OCMS.controls.termsconditions.selectors.container);
    if (container.length) {
      // Check the checkbox
      const checkbox = container.find('input[type=checkbox]');
      if (checkbox.length) {
        checkbox.prop('readonly', true);
        checkbox.click();
        checkbox.prop('checked', false);
      }
      const errorLabel = container.find('label.validationerror');
      if (errorLabel.length && checkbox.length) {
        checkbox.valid();
      }
    }
  },

  /**
   * Init function called before all others.
  */
  init: () => {
      /* TEST ONLY */
      /*
      if (!OCMS.GlobalVars.IsProd) {
          // Set France as a test country
          this.countriesList.push("france");
          // Set US as a test country
          this.countriesList.push("united states");
      }
      */

    const isIE = OCMS.utils.browserDetection.isIE();
    const isEdge = OCMS.utils.browserDetection.isEdge();

    /* Setup Zipcode popin specially for IE 11 and lower */
    if (isIE && !isEdge) {
      let port = document.location.port;
      const protocol = document.location.protocol;
      const origin = [protocol, '//', document.location.host, port].join('');

      if (port !== undefined && port !== null && port !== '') {
        port = [':', port].join('');
      }

      let url = ['http://mini.loccitane.co.kr/newsite/korzip/zip_search_new.asp?url=', origin].join('');

      if (OCMS.GlobalVars.Brand === 'mel') {
        url = ['http://mini.melvita.co.kr/kor/zip_code/zip_search_new.asp?url=', origin].join('');
      } else if (OCMS.GlobalVars.Brand === 'erb') {
        url = ['http://mini.melvita.co.kr/erborian/zip_search_new.asp?url=', origin].join('');
      }

      const popinContent = `<iframe src="${url}" height="500" width="550" frameborder="0"></iframe>`;
      /* See OCMS.Popin.js to see popin implementation */
      popinCreate(popinContent, 'korea-zip');
    }

    let i = 0;
    for (; (i < window.OCMS.controls.termsconditions.countriesList.length)
      && (OCMS.GlobalVars.Country.toLowerCase() !==
        (window.OCMS.controls.termsconditions.countriesList[i]).toLowerCase()
      );
      i += 1) {
      return;
    }
    if (window.OCMS.controls.termsconditions.countriesList.length
        && (i < window.OCMS.controls.termsconditions.countriesList.length)) {
      const container = $(window.OCMS.controls.termsconditions.selectors.container);
      if (container.length) {
        const checkbox = container.find('input[type=checkbox]');
        if (checkbox.length) {
          checkbox.prop('readonly', true);
        }

        const label = container.find(window.OCMS.controls.termsconditions.selectors.label);
        if (label.length && label.is('label')) {
          const link = $(label).find('a');
          if (link.length) {
            window.OCMS.controls.termsconditions.labelInitialHTML = label.html();
            label.html(link);
          }
        }
      }

      // Set handler for a click on the "T&C" container
      $(document).on('click', window.OCMS.controls.termsconditions.selectors.container, window.OCMS.controls.termsconditions.handleClick);
    }
  },
};
window.OCMS.controls = window.OCMS.controls || {};
window.OCMS.controls.termsconditions = openKoreaTermsConditions;

/**
 * Recusive timeout handler catching zipcode cookie, it's used to fix HTTPS regression under IE 11 and lower.
 *
 * @return {[Boolean]} Return true on specific cookie capture, otherwise false.
 */
function getZipCodeCookie() {
  let result = false;

  if (Cookies.get('postcode') !== undefined) {
    const $zip = $('input:data(koreaZip)');
    const $address = $('input:data(koreaAddress)');
    const $city = $('input:data(koreaCity)');
    const $state = $('select:data(koreaState)');
    const $popin = $('#korea-zip');
    const $popContent = $popin.find('.js-popinBody');
    const src = $popContent.children('iframe').attr('src');
    const tabArgs = $.cookie('postcode').split('&');
    let zipcode = '';
    let address = '';
    let address2 = '';
    let city = '';
    let state = '';
    let arg = [];

    for (let i = 0, len = tabArgs.length; i < len; i += 1) {
      arg = tabArgs[i].split('=');

      if (arg.length === 2) {
        switch (arg[0]) {
          case 'zipcode': zipcode = unescape(arg[1]); break;
          case 'address1': address = unescape(arg[1]); break;
          case 'address2': address2 = unescape(arg[1]); break;
          case 'city': city = unescape(arg[1]); break;
          case 'region': state = unescape(arg[1]); break;
          default: break;
        }
      }
    }

    if ($zip !== undefined && zipcode !== '') {
      $zip.val(zipcode);
      $zip.removeData('koreaZip');
    }

    if ($address !== undefined && (address + address2) !== '') {
      $address.val(`${address} ${address2}`);

      $address.removeData('koreaAddress');
    }

    if ($city !== undefined && city !== '') {
      $city.val(city);
      $city.removeData('koreaCity');
    }

    if ($state !== undefined && state !== '') {
      const options = $state.find('option');
      const selectedOpt = $(options).filter(function selectOptFct() {
        return $(this).html() === state;
      });

      $state.val($(selectedOpt).val());

      $state.trigger('change');
      $state.removeData('koreaState');
    }

    popinClose('#korea-zip');

    /* Reset template style (fix child height setup problem) then replace previous iframe to counter it disappearance */
    $popin.attr('style', 'z-index:-99999999; display:block; hidden:hidden; opacity:0;');
    $popContent.html(`<iframe src="${src}" height="500" width="550" frameborder="0"></iframe>`);

    result = true;
  } else {
    setTimeout(getZipCodeCookie, 800);
  }
  return result;
}


function openKoreaZipFinder(zip, address, city, state) {
  const isIE = OCMS.utils.browserDetection.isIE();
  const isEdge = OCMS.utils.browserDetection.isEdge();

  $(`#${zip}`).data('koreaZip', true);
  $(`#${address}`).data('koreaAddress', true);
  $(`#${city}`).data('koreaCity', true);
  $(`#${state}`).data('koreaState', true);

  /*
   * Special behaviour due to mixed content limitation in IE 11 and lower.
   * Opening http document through https one trigger limitation in iframe communication in these browser.
   */
  if (isIE && !isEdge) {
    /* Remove a potential previous cookie */
    Cookies.remove('postcode');
    /* Remove special style override on popinTemplateIframe */
    $('#korea-zip').removeAttr('style');
    /* see OCMS.Popin.js to see popin implementation */
    popinOpen('#korea-zip');
    /* Start a recursive timeout to catch the JS cookie set in  */
    setTimeout(getZipCodeCookie, 800);
  } else {
    const protocol = document.location.protocol;
    let port = document.location.port;

    if (port !== undefined && port !== null && port !== '') {
      port = [':', port].join('');
    }

    const origin = [protocol, '//', document.location.host, port].join('');
    let url = ['http://mini.loccitane.co.kr/newsite/korzip/zip_search_new.asp?url=', origin].join('');

    if (OCMS.GlobalVars.Brand === 'mel') {
      url = ['http://mini.melvita.co.kr/kor/zip_code/zip_search_new.asp?url=', origin].join('');
    } else if (OCMS.GlobalVars.Brand === 'erb') {
      url = ['http://mini.melvita.co.kr/erborian/zip_search_new.asp?url=', origin].join('');
    }

    window.open(url, 'WindowsZipCode', 'location=no,status=no,scrollbars=yes,width=450,height=450');
  }
}

/*
  NATIONAL MOBILE NUMBER in Korea have 10 or 11 digits and starts with specific prefixes.
 */
$.validator.addMethod(
    'mobileValidation',
    (phoneNumber) => {
      if (phoneNumber === undefined || phoneNumber === null || phoneNumber === '') {
        return false;
      }

      /*
       Phone number should have at least 10 digits
       And also have a maximum of 11 digits
       */
      if (phoneNumber.length < 10 || phoneNumber.length > 11) {
        return false;
      }

      /*
       Here we check there is only 10 or 11 numbers.
       Also the phone number should start with :
        - 010
        - 011
        - 016
        - 017
        - 018
        - 019
       */
      return (/^0(10|11|16|17|18|19)[0-9]{7,8}$/).test(phoneNumber);
    }
);

$(() => {
  $("[data-id='tel']").mask('999999999?99', { placeholder: '' });
  $("[data-id='mobile']").mask('9999999999?9', { placeholder: '' });
  $("[data-id='optional2']").mask('9999999999?9', { placeholder: '' });

  openKoreaTermsConditions.init();
});

$(document).on('initialized.ocms.ultimate-form', (event, form) => {
  if (form === undefined || form === null) {
    return;
  }

  if (form.id !== 'newsletter' && !form.zipField.siblings('button').length) {
    const $button = $('<button type="button" class="a-btn a-btn--primary-2">우편번호 검색</button>');

    form.zipField.after($button);

    $button.on('click', () => {
      openKoreaZipFinder(form.zipField.attr('id'), form.addressField.attr('id'), form.cityField.attr('id'), form.stateField.attr('id'));
    });
  }

  const $containers = $(`[id^='${form.id}'][id$='_Container'], [id^='${form.id}'][id$='_Container_Field']`);
  const $stateContainer = $containers.filter("[id*='state']");

  const $fields = $(`[data-form='${form.id}']`);
  const $stateField = $fields.filter("[data-id='state']");

  if ($stateField.data('hidden') === true) {
    $stateContainer.hide();
  }

  // if (form.id === "checkout" &&
  //    OCMS !== undefined && OCMS !== null &&
  //    OCMS.QAS !== undefined && OCMS.QAS !== null &&
  //    OCMS.QAS.ZipFinders !== undefined && OCMS.QAS.ZipFinders !== null) {
  //    OCMS.QAS.ZipFinders.register({
  //        formId: "checkout",
  //        resources: {
  //            finderLabel: "Enter postcode",
  //            finderButton: "ADDRESS FINDER",
  //            resultLabel: "Choose your address",
  //            skipLabel: "Ordering outside of the Korea ?",
  //            skipButton: "Click here to enter your international address"
  //        },
  //        onSelect: function (form, values) {
  //            if (form === undefined || form === null) {
  //                return;
  //            }

  //            form.address(values[0].address);
  //            form.address2(values[1].address);
  //            form.city(values[2].address);
  //            form.zip(values[4].address);
  //        }
  //    });
  // }
});

$(document).on('click', '.accordion_forceRegister', () => {
  const formId = OCMS.currentForm.FormId;
  OCMS.UltimateForms.register(formId, true);
});



// WEBPACK FOOTER //
// ./js/countryForm/korea.form.js